/// <amd-module name="Wit/WorkItemForm/Links/WorkItemDetailsLinksControl" />
import * as React from "react";
import { Control } from "Wit/Clients/Wit/Contracts/WorkItemFormLayout";
import { getLinkableWorkItemTypeFilterForControl, getLinkTypeFilterForControl } from "Wit/Common/Utils/WorkItemUtils/LinkTypeFilter";
import { extractInfoFromControlMetadata } from "Wit/Common/Utils/WorkItemUtils/extractInfoFromControlMetadata";
import { ILinksControlProps, LinksControl } from "./Controls/LinksControl";

interface IWorkItemDetailsLinksControlProps {
    control: Control;
}

export function WorkItemDetailsLinksControl({ control }: IWorkItemDetailsLinksControlProps) {
    const linksControlInfo = getLinksControlInfoFromMemo(control);

    return <LinksControl {...linksControlInfo} />;
}

/**
 * Referential equality for out filter functions is nice because the link type service uses it as
 * a key for identifying existing link data. This memo also saves us from parsing XML on every
 * render. Note: useMemo does not do what we want here because it is attached to a particualar
 * component "instance".
 */
const linksControlInfoMemo = new Map<string, ILinksControlProps>();

function getLinksControlInfoFromMemo(control: Control): ILinksControlProps {
    const metadata = control.metadata;
    if (!linksControlInfoMemo.has(metadata)) {
        const linksControlInfo = extractInfoFromControlMetadata(metadata);
        const { allowedLinkTypes, allowedWitLinkTypeEnds, allowedWorkItemTypes, ...otherControlInfo } = linksControlInfo;

        const linkTypeFilter = getLinkTypeFilterForControl(metadata);
        const linkableWorkItemTypeFilter = getLinkableWorkItemTypeFilterForControl(metadata);

        const props: ILinksControlProps = {
            ...otherControlInfo,
            linkTypeFilter,
            linkableWorkItemTypeFilter,
            showZeroDataExperience: true,
            controlId: control.id
        };

        linksControlInfoMemo.set(metadata, props);
    }
    return linksControlInfoMemo.get(metadata)!;
}
